var _circle, _path, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame1000004587(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 57,
    viewBox: "0 0 48 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.8613,
    cy: 23.5,
    r: 22.2445,
    stroke: "#006D77",
    strokeWidth: 2.51096
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 14H21C20.6022 14 20.2206 13.842 19.9393 13.5607C19.658 13.2794 19.5 12.8978 19.5 12.5C19.5 12.1022 19.658 11.7206 19.9393 11.4393C20.2206 11.158 20.6022 11 21 11H30C30.3978 11 30.7794 11.158 31.0607 11.4393C31.342 11.7206 31.5 12.1022 31.5 12.5C31.5 12.8978 31.342 13.2794 31.0607 13.5607C30.7794 13.842 30.3978 14 30 14ZM30 20.045H18C17.6022 20.045 17.2206 19.887 16.9393 19.6057C16.658 19.3244 16.5 18.9428 16.5 18.545C16.5 18.1472 16.658 17.7657 16.9393 17.4843C17.2206 17.203 17.6022 17.045 18 17.045H30C30.3978 17.045 30.7794 17.203 31.0607 17.4843C31.342 17.7657 31.5 18.1472 31.5 18.545C31.5 18.9428 31.342 19.3244 31.0607 19.6057C30.7794 19.887 30.3978 20.045 30 20.045ZM27 35.045C26.602 35.0451 26.2202 34.8876 25.938 34.607L16.938 25.607C16.6648 25.3241 16.5136 24.9452 16.517 24.5519C16.5204 24.1586 16.6782 23.7824 16.9563 23.5043C17.2344 23.2262 17.6106 23.0684 18.0039 23.065C18.3972 23.0616 18.7761 23.2128 19.059 23.486L28.059 32.486C28.2681 32.6958 28.4104 32.9627 28.468 33.2533C28.5256 33.5438 28.496 33.8449 28.3827 34.1186C28.2694 34.3923 28.0777 34.6263 27.8316 34.7912C27.5856 34.956 27.2962 35.0444 27 35.045Z",
    fill: "#FEB423"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 26H18C17.6022 26 17.2206 25.842 16.9393 25.5607C16.658 25.2794 16.5 24.8978 16.5 24.5C16.5 24.1022 16.658 23.7206 16.9393 23.4393C17.2206 23.158 17.6022 23 18 23H21C23.481 23 25.5 20.981 25.5 18.5C25.5 16.019 23.481 14 21 14H18C17.6022 14 17.2206 13.842 16.9393 13.5607C16.658 13.2794 16.5 12.8978 16.5 12.5C16.5 12.1022 16.658 11.7206 16.9393 11.4393C17.2206 11.158 17.6022 11 18 11H21C25.134 11 28.5 14.363 28.5 18.5C28.5 22.637 25.134 26 21 26Z",
    fill: "#FEB423"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.8613,
    y: 53,
    width: 22,
    height: 4,
    rx: 2,
    fill: "#006D77"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame1000004587);
export default __webpack_public_path__ + "static/media/Frame 1000004587.d439fbf7173e526245ac3daa86c3feea.svg";
export { ForwardRef as ReactComponent };